export const EmployeeIdSearchFormFields = {
  employeeId: 'employeeId',
} as const;
